import { render, staticRenderFns } from "./tweet-form.vue?vue&type=template&id=39e1c94e&scoped=true&"
import script from "./tweet-form.vue?vue&type=script&lang=ts&"
export * from "./tweet-form.vue?vue&type=script&lang=ts&"
import style0 from "./tweet-form.vue?vue&type=style&index=0&id=39e1c94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1c94e",
  null
  
)

export default component.exports